import React, { useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import isUrl from "is-url";
import { useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";
import mixpanel from "mixpanel-browser";

function InstantAudioPreview(props) {
  const history = useHistory();
  const [url, setUrl] = useState("");

  useEffect(() => {
    mixpanel.track("Open Enter URL Page (Onboarding)");
  }, []);

  if (isUrl(url)) {
    return (
      <Redirect to={`/onboarding?article_url=${encodeURIComponent(url)}`} />
    );
  }
  return (
    <div className="center">
      <h1 className="headline">Enter an Article URL</h1>
      <h2 className="subheadline">It'll be ready to listen in 2 seconds</h2>

      <div className="cta-div">
        <div className="box">
          <input
            autoFocus={isMobile ? false : true}
            className="input"
            type="url"
            placeholder="Enter an article URL"
            onChange={(e) => {
              e.preventDefault();

              if (isUrl(e.target.value)) {
                mixpanel.track("Enter Article URL (Onboarding)", {
                  article_url: e.target.value,
                });

                history.push(
                  `/onboarding?article_url=${encodeURIComponent(
                    e.target.value
                  )}`
                );
              }
            }}
          ></input>
        </div>

        <Link
          onClick={(e) => {
            mixpanel.track("Skip to Sample Article (Onboarding)");
          }}
          className="sub-cta-link"
          to={`/onboarding?article_url=${encodeURIComponent(
            "http://paulgraham.com/newideas.html"
          )}`}
        >
          Not sure? Try a sample
        </Link>
      </div>
    </div>
  );
}

export default InstantAudioPreview;
